module.exports = __webpack_public_path__ + "static/media/globulos_rojos_2x.a5f32829.png";